export const tapume = {
  titulo: 'Manutenção em andamento',
  conteudo: [
    'Estamos lidando com uma instabilidade no sistema e já estamos trabalhando para deixar sua experiência na SAVA ainda melhor.',
    'Enquanto isso, acesse o Ambiente de Avaliações por meio do link: [HIPERLINK]',
    'Em breve, a SAVA vai ficar disponível novamente. Boas provas!',
  ],
  hyperlink: 'https://simulado.ibmec.br/alunos/',
};
